import { Component, Input } from '@angular/core';
import { AppConfigService } from 'src/app/app-config.service';

@Component({
  selector: 'app-header',
  templateUrl: './app.header.component.html',
  styleUrls: ['./app.header.component.scss'],

  standalone: false,})
export class AppHeaderComponent {
  @Input() showPerimetre: boolean = false;
  title: string = 'Caaks';

  constructor(private configService: AppConfigService) {
    this.title = this.configService.getValue('applicationTitle');
  }
}
